
import { locale } from "../../../services/LocaleService.js";

export const TagCloudSection = (onTagClick) => {
    const section = document.createElement('section');
    // section.className = "mb-10"; // [FIX] Removed internal margin

    const header = document.createElement('div');
    header.className = "flex items-center gap-2 mb-4 px-1 md:px-0";
    header.innerHTML = `
        <span class="text-xl">🏷️</span>
        <h2 class="text-xl font-bold text-gray-900">${locale.t('main.tag_cloud')}</h2>
    `;
    section.appendChild(header);

    const container = document.createElement('div');
    container.className = "flex flex-wrap gap-2 px-1 md:px-0";

    const tags = [
        "판타지", "로맨스", "무협", "드라마", "일상", "개그", "스릴러", "학원물",
        "먼치킨", "회귀", "빙의", "시스템", "성장", "복수"
    ];

    const TAG_KEY_MAP = {
        "판타지": "fantasy",
        "로맨스": "romance",
        "무협": "martial_arts",
        "드라마": "drama",
        "일상": "slice_of_life",
        "개그": "comedy",
        "스릴러": "thriller",
        "학원물": "school",
        "먼치킨": "munchkin",
        "회귀": "regression",
        "빙의": "possession",
        "시스템": "system",
        "성장": "growth",
        "복수": "revenge"
    };

    tags.forEach(tag => {
        const chip = document.createElement('button');
        chip.className = "px-4 py-2 bg-gray-100 dark:bg-zinc-800 text-gray-600 dark:text-gray-300 hover:bg-indigo-100 hover:text-indigo-600 dark:hover:bg-indigo-900/50 dark:hover:text-indigo-300 text-sm rounded-full transition-colors font-medium";

        const key = TAG_KEY_MAP[tag];
        const displayName = key ? locale.t('tag.' + key) : tag;
        chip.innerText = "#" + displayName;

        chip.onclick = () => {
            if (onTagClick) onTagClick({ value: tag, label: displayName });
        };

        container.appendChild(chip);
    });

    section.appendChild(container);
    return section;
};
